<div class="purchase-underlying-cover-covered-call-rebalance-settings">
  <div class="flex-row">
    <div class="flex-column flex-column-header flex-green-button-header">
      <strong>Options</strong>
    </div>
    <div class="flex-column flex-green-button-container">
      <div>
        <button class="btn-medium-secondary" (click)="addAllocations()"
        [disabled]="isReadOnly" style="width: auto;margin-left:0px;">Select from Option Chain</button>
      </div>
    </div>
  </div>
  <div class="flex-row  zero-bottom-margin">
    <div class="flex-column flex-column-header">
      <strong>Buy using cash above:</strong>
    </div>
    <div class="flex-column">
      <div class="checkboxes-horizontal-align">
        <div class="flex-radio-item">
          <div>
            <div>
              <p-radioButton name="buyUsingCashTarget" inputId="pusitem1" [value]="true"
                [(ngModel)]="isCashTarget" [disabled]="isReadOnly" (ngModelChange)="onCashMinTargetChange();">
              </p-radioButton>
                <label for="pusitem1" >Cash target</label>
            </div>
            <div>
              Only the cash exceeding an account's<br>
              cash target will be used for the buy.<br>
              (Set-aside cash is never used for this.)
            </div>
          </div>
        </div>
        <div class="flex-radio-item">
          <div>
            <div>
              <p-radioButton name="buyUsingCashMinimum" inputId="pusitem2"  [value]="false"
                [(ngModel)]="isCashTarget" [disabled]="isReadOnly" (ngModelChange)="onCashMinTargetChange();">
              </p-radioButton>
                <label for="pusitem2" >Cash minimum</label>
            </div>
            <div>
              All the cash exceeding an account's minimum<br>
              cash value will be used for the buy.<br>
              (Set-aside cash is never used for this.)
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
  <div class="flex-row">
    <div class="flex-column flex-column-header  flex-option-settings-header">
      <strong>Options settings</strong>
      <span class="tooltipIcon infoIcon suggested-name" calltoaction calltoactionPosition="right"
      [calltoactionTemplate]="optionSettingsInfoToolTipIcon"></span>
    </div>
    <div class="flex-column">
      <div class="flex-option-settings-container">
        <div class="option-settings-row-container">
          Specify values to apply to all securities listed below (optional)
        </div>
        <div class="option-settings-row-container">
          <div class="option-settings-column-container  option-settings-column-container-margin-right">
            <div class="option-settings-header">Underlying % of portfolio:</div>
            <div>
              <irb-number-text-box [(value)]="defaultPercentOfUnderlyingToPurchase" places="2" min="1"
                max="100" [isPercentage]="true" [disabled]="isReadOnly"
              width="80px"></irb-number-text-box>
            </div>
            <div>%</div>
            <div>
              <button id="applyPercentOfUnderlyingToPurchase"
                class="btn-medium-secondary" (click)="applyPercentOfUnderlyingToPurchase()"
              [disabled]="isReadOnly || this?.data?.allocations?.length ===0">Apply</button>
            </div>
          </div>
          <div class="option-settings-column-container">
            <div class="option-settings-header">Percent of underlying to cover:</div>
            <div> <irb-number-text-box [(value)]="defaultPercentOfUnderlyingToCover" places="2" min="1"
              max="100" [isPercentage]="true" invalidRangeMessage="This value is out out of range." [disabled]="isReadOnly"
            width="80px"></irb-number-text-box>
          </div>
          <div>%</div>
          <div>
            <button id="applyPercentOfUnderlyingToCover"
              class="btn-medium-secondary" (click)="applyPercentOfUnderlyingToCover()"
            [disabled]="isReadOnly || this?.data?.allocations?.length ===0">Apply</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="flex-row">
  <div class="flex-column flex-column-header"></div>
  <div class="flex-column" style="width:100%;margin-left:20px;margin-right:20px;">
    @if (!isUitest) {
      <div style="width:100%;">
        <irb-inventory-grid class="purchase-underlying-grid" [style.height]="'200px'" [gridHeight]="'200px'"
          [showSideBar]="false" [gridOptions]="gridOptions"
          [frameworkComponents]='frameworkComponents' (gridReady)="onGridReady($event)">
        </irb-inventory-grid>
      </div>
    }
  </div>

</div>
</div>
<ng-template #optionSettingsInfoToolTipIcon>
  <div>
    After selecting options chains, you can use these to quickly apply the same
    percentages for all symbols, so you don't have to enter the same settings
    for each security. You can edit the settings for any individual security
    after applying these same settings to all.
  </div>
</ng-template>
